module.exports = __webpack_public_path__ + "static/media/PIXEL-OP-Li-2100.c02bb624.jpg";